import React, {Component} from "react";
import { Link, Navigate } from "react-router-dom";
import axiosBaseURL from "../httpCommon";

class LocalEvents extends Component {
constructor(props){
        super();
        this.state={
            localEvents: [],
            organization: [],
            redirect: false,
            loggedIn: window.localStorage.getItem("isLoggedIn"),
            authUser: JSON.parse(window.localStorage.getItem("userData"))
        }
    }

    async componentDidMount(){

        await axiosBaseURL.get('api/v1/events', {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.state.authUser.token
            }
        })
            .then(response => {
                if (response.data.status === 200) {
                    this.setState({
                        localEvents: response.data.localEvents,
                        organization: response.data.organization
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render (){
        if(!this.state.loggedIn === true){
            return <Navigate to ="/login"/>
        }

        const allLocalEvents = this.state.localEvents
        const LocalEvents = allLocalEvents.map((allLocalEvent, key) => {
            return <div key={key}>
                <div className="cart-box px-15">
                    <Link to={"/event/" + allLocalEvent.id} className="cart-img">
                        <img src={allLocalEvent.event_picture} className="img-fluid" alt="" width="60px" height="auto"/>
                    </Link>
                <div className="cart-content">
                    <Link to={"/event/" + allLocalEvent.id}>
                        <h4>{allLocalEvent.title}</h4>
                    </Link>
                    <h5 className="content-color">by 60 Plus Care</h5>                
                </div>
            </div>
            <div className="divider"></div>
        </div>
        });

        return(
            <>


    <header>
        <div className="back-links">
            <Link to={'/organization/' + this.state.organization.id}>
                <i className="iconly-Arrow-Left icli"></i>
                <div className="content">
                    <h2>{this.state.organization.name}</h2>
                </div>
            </Link>
        </div>
        <div className="header-option">
            <ul>
                <li>
                    <Link to={"/"}><i className="iconly-Home icli"></i></Link>
                </li>
            </ul>
        </div>
    </header>

    <section className="cart-section pt-0 top-space section-b-space">
        
        {this.state.localEvents.length > 0 ?
            LocalEvents
            :
            (<div><p className="">You have No Events Available.</p></div>)
        }
  
    </section>
            </>
        );
    }
}

export default LocalEvents;